// Für volle die API-Dokumentation, einschließlich Codebeispiele, besuchen Sie http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});